// extracted by mini-css-extract-plugin
module.exports = {"banner":"home-page_banner__3vUO5","content":"home-page_content__8g_pL"};